import { NumericInput } from "@blueprintjs/core";
import styled from "@emotion/styled";

import CreditSVG from "@/../../hypetrain/static/img/credit.svg";
import { EmbedSvg } from "@/components/helpers/ui/EmbedSvg";
import { Box, Flex } from "@/components/layout/flexbox";
import { SUBTEXT_COLOR } from "@/css/constants";
import { formatCreditsLowerCase, parseDecimal } from "@/utils/string";

interface SetCreditsFormProps {
  creditsText: string;
  amount: string;
  setAmount: (amount: string) => void;
  numberOfEmails?: number;
  workspaceCredit?: string | null;
  userCredit?: string | null;
}

export function SetCreditsForm({
  creditsText,
  amount,
  setAmount,
  numberOfEmails = 1,
  workspaceCredit,
  userCredit,
}: SetCreditsFormProps) {
  const totalCredits = (parseFloat(amount) * numberOfEmails).toFixed(2);

  const max =
    (parseDecimal(workspaceCredit) + parseDecimal(userCredit)) /
    (numberOfEmails > 0 ? numberOfEmails : 1);

  return (
    <Flex flexDirection="column" style={{ gap: 16 }}>
      <Flex alignItems="center">
        <Container>
          <NumericInput
            style={{ textAlign: "center", width: 100 }}
            value={amount}
            onValueChange={(valueAsNumber, valueAsString) => {
              if (valueAsNumber < 0) {
                setAmount("0");
              } else if (valueAsNumber > max) {
                setAmount(max.toString());
              } else if (isNaN(valueAsNumber)) {
                return;
              } else {
                setAmount(valueAsString);
              }
            }}
          />
        </Container>
        <Box ml={2} flex={1}>
          {numberOfEmails > 1 ? (
            <Box>
              {formatCreditsLowerCase(amount)} each{" "}
              <Box css={{ color: SUBTEXT_COLOR, display: "inline" }}>
                ({totalCredits} credits total)
              </Box>
            </Box>
          ) : (
            <Box>{formatCreditsLowerCase(amount)}</Box>
          )}
        </Box>
      </Flex>
      <Flex css={{ color: SUBTEXT_COLOR }}>
        Your workspace has
        <Flex mx={1} alignItems="center">
          <EmbedSvg src={CreditSVG} height={14} width={14} />
          <Box ml={1}>{creditsText.toLowerCase()}</Box>
        </Flex>
        to disburse
      </Flex>
    </Flex>
  );
}

const Container = styled("div")`
  input[type="number"]::-webkit-inner-spin-button,
  input[type="number"]::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
`;
